import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { timer } from 'rxjs';
import { Point, ScoutPath, MapImageOverlay, ScoutPoint } from '../../../../core/models';
import { ScoutPathPlotterComponent } from '../../../scout-path/scout-path-plotter/scout-path-plotter.component';
import { ScoutTaskService } from '../../../../core/services';
import domtoimage from "dom-to-image";
import { skipWhile, take } from 'rxjs/operators';

@Component({
  selector: 'app-scout-path-image',
  templateUrl: './scout-path-image.component.html',
  styleUrls: ['./scout-path-image.component.scss']
})
export class ScoutPathImageComponent implements OnInit, AfterViewInit {

  @Input() scoutPath : ScoutPath
  @Input() selectedScoutPoint : ScoutPoint
  @Input() buildingPoints : Point[]
  @Input() zoomLevel : number = 22
  @Input() mapStyle = { width: '600px', height: '600px' }
  @Input() title : string = ''
  @Input() overlay : MapImageOverlay
  @Input() imageCreateDelayMs = 7000
  
  @Output() imageRenderComplete = new EventEmitter<ScoutPathImageComponent>()
  @Output() imageRenderRestarted = new EventEmitter<ScoutPathImageComponent>()

  @ViewChild('scoutPathPlotter') scoutPathPlotter : ScoutPathPlotterComponent
  @ViewChild('scoutPathPlotter', { read: ElementRef }) scoutPathPlotterRef : ElementRef
  @ViewChild('plotterPanel') plotterPanel : ElementRef

  errorMsg : string

  public plotterImageDataUrl : string

  constructor(
      private scoutTaskService: ScoutTaskService
  ){       
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
      
  
  }

  onMapReady(leafletMapReady : boolean) {
    if ( !leafletMapReady ) {
      return
    }
    timer(0).subscribe( async _=>{ 

      this.scoutTaskService.updateScoutPathContext(this.scoutPath, this.buildingPoints)
      this.scoutPathPlotter.plotScoutPath(this.scoutPath)
      if ( this.selectedScoutPoint) {
        this.scoutPathPlotter.setSelectedPoint( this.selectedScoutPoint, false )
      }
      timer(0).subscribe( async _ => {
        if ( this.zoomLevel ) {
          this.scoutPathPlotter.map.setZoom(this.zoomLevel)
        }
        const mapToImage = async (delayMs:number) => {
          await timer(delayMs).toPromise() // give map tiles time to render
          await this.scoutPathPlotter.overlayIntializing.pipe( skipWhile(bLoading=>bLoading), take(1) ).toPromise()
          this.errorMsg = ''
          const options = {
            imagePlaceholder: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
          }
          const pngPromise : Promise<string> = domtoimage.toPng(this.plotterPanel.nativeElement, options)
          const dataUrl = await pngPromise
          this.plotterImageDataUrl = dataUrl
        }
        try {
          await mapToImage(this.imageCreateDelayMs*0.5)          
        } catch ( error ) {            
          console.error(error)
          try { 
            await mapToImage(this.imageCreateDelayMs*1.5)
          } catch ( error ) {
            console.error(error)
            this.errorMsg = 'Failed creating map image. ' 
              + this.scoutTaskService.extractErrorMsg(error)
          }
        } finally {
          this.imageRenderComplete.emit(this)
        }
      })
    })    
  }

  protected correctLocalObjRendering() {
    var svg = this.scoutPathPlotterRef.nativeElement.querySelector("svg.leaflet-zoom-animated");
    var transform = svg.style.transform.split(",");
    var x = parseFloat(transform[0].split("(")[1].replace("px", ""));
    var y = parseFloat(transform[1].replace("px", ""));
    svg.style.left = "" + (x*-1) + "px";
    svg.style.top = "" + (y*-1) + "px";
  }


  rebuild() {
    this.plotterImageDataUrl = null
    this.errorMsg = ''
    this.imageRenderRestarted.emit()
  }

  retryStarting = false
  retry() {
    this.retryStarting = true // this will remove leaflet map
    timer(0).subscribe(_=>{
      this.retryStarting = false // this will add leaflet map and it will re-initialize
      this.rebuild()
    })
  }
}
